import { getValidationSchema } from '../form/common.validators';
import { FORM_FIELDS } from '../../constants';

export const schema = () =>
    getValidationSchema([FORM_FIELDS.PURPOSE, FORM_FIELDS.AMOUNT, FORM_FIELDS.REGION, FORM_FIELDS.PERIOD]);
